import { render, staticRenderFns } from "./codeModal.vue?vue&type=template&id=133d2b94"
import script from "./codeModal.vue?vue&type=script&lang=js"
export * from "./codeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports